import { withVersions } from "v2/hocs/withVersions";
import AppSideBarProfileUIV1 from "./AppSideBarProfile/v1";
import AppSideBarHeaderUIV1 from "./AppSideBarHeader/v1";
import AppNavItemUIV1 from "./NavItem/v1";
import AppSideBarWrapperUIV1 from "./AppSideBarWrapper/v1";

const AppSideBarProfile = {
  UserName: withVersions({
    v1: AppSideBarProfileUIV1.UserName,
    v2: AppSideBarProfileUIV1.UserName,
  }),
  Logout: withVersions({
    v1: AppSideBarProfileUIV1.Logout,
    v2: AppSideBarProfileUIV1.Logout,
  }),
};

const AppSideBarHeader = withVersions({
  v1: AppSideBarHeaderUIV1,
  v2: AppSideBarHeaderUIV1,
});

const AppSideBarNav = {
  Wrapper: withVersions({
    v1: AppNavItemUIV1.Wrapper,
    v2: AppNavItemUIV1.Wrapper,
  }),
  Nav: withVersions({
    v1: AppNavItemUIV1.Nav,
    v2: AppNavItemUIV1.Nav,
  }),
  Icon: withVersions({
    v1: AppNavItemUIV1.Icon,
    v2: AppNavItemUIV1.Icon,
  }),
};

const AppSideBarWrapper = withVersions({
  v1: AppSideBarWrapperUIV1,
  v2: AppSideBarWrapperUIV1,
});

const AppSideBar = {
  Profile: AppSideBarProfile,
  Header: AppSideBarHeader,
  Nav: AppSideBarNav,
  Wrapper: AppSideBarWrapper,
};

export default AppSideBar;
